export default __webpack_public_path__ + "static/media/pickupAssigned.23cdf3f7.svg";